import { Injectable } from '@angular/core';
import { UserService } from '@carm/_core/access-control-mgt/facade/user.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import * as ProgramListActions from '../actions/program-list.actions';
import { ProgramAccountProfileService } from '@carm/_core/program-account-profile/services/program-account-profile.service';

@Injectable()
export class ProgramListEffects {

  constructor(private actions$: Actions,
              private userService: UserService,
              private programAccountProfileService: ProgramAccountProfileService) {}

  loadInactivePrograms$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ProgramListActions.loadInactivePrograms),
      mergeMap(() => this.userService.getLastUsedSelectedBusinessId().pipe(take(1))),
      mergeMap( (businessId: string) => {
            return this.programAccountProfileService.getInactiveProgramList(businessId).pipe(
              map((data) => ProgramListActions.loadInactiveProgramsSuccess({data})),
              catchError((error) => of(ProgramListActions.loadInactiveProgramsFailure({ error }))),
            );
        },
      ),
    );
  });

}
